<template>
  <div v-if="consultant">
    <div class="panel-body no-padding">

      <div id="chat-discussion" class="chat-discussion border-right" :class="$auth.user().id !== consultant.id ? 'col-xs-12' : 'col-xs-8 col-md-9'">

        <template v-if="conversation.length !== 0">

          <div class="user-discussion" v-for="(msg, key) in conversation" v-bind:key="key" >
            <template v-if="msg.sender.id === user.id">
              <div class="chat-message right">
                <img class="message-avatar" v-bind:src="$apiUrl +'/uploads/user/avatar.png' " alt="" >
                <div class="message">
                  <a class="message-author" href="#">{{msg.sender.firstname}} {{msg.sender.lastname}} </a>
                  <span class="message-date">{{msg.created_at | moment('LLL')}}</span>
                  <span class="message-content">{{msg.message}}</span>
                </div>
              </div>
            </template>
            <template v-if="msg.sender.id === interlocutor.id">
              <div class="chat-message left">
                <img class="message-avatar" v-bind:src="$apiUrl +'/uploads/user/avatar.png' " alt="" >
                <div class="message">
                  <a class="message-author" href="#">{{msg.sender.firstname}} {{msg.sender.lastname}} </a>
                  <span class="message-date">{{msg.created_at | moment('LLL')}}</span>
                  <span class="message-content">{{msg.message}}</span>
                </div>
              </div>
            </template>
          </div>
        </template>
        <div v-else class="col-md-12 text-center vertical-mid" style="height: 100%">
          <h5 class="font-bold" v-if="$auth.user().id === consultant.id">No message yet with expert</h5>
          <h5 class="font-bold" v-else>No message yet</h5>
        </div>

      </div>
      <div v-if="$auth.user().id === consultant.id" class="col-xs-4 col-md-3 ">
        <div class="chat-users">
          <div style="padding: 15px">
            <h5 class="text-center font-bold">Experts <span>({{chatUsers.length}})</span></h5>
          </div>
          <div class="users-list border-top">

            <div v-if="chatUsers.length !== 0" class="">

              <div class="chat-user " :class="interlocutor.id === user.id ? 'active' : ''"
                   v-for="(user, key) in chatUsers" v-bind:key="key" v-on:click="setInterlocutor(user)">

                <img class="chat-avatar" v-bind:src="$apiUrl + '/uploads/user/avatar.png'"  alt="" >
                <div class="chat-user-name">
                  <a>{{user.firstname}} {{user.lastname}}</a>
                </div>
                <span v-if="user.last_login" class="message-date"> Last login:  {{user.last_login | moment('LLL')}} </span>
              </div>
            </div>
            <div v-else class="col-md-12 text-center vertical-mid " style="height: 380px">
              <h5 class="font-bold">  No Conversation for this Question </h5>
            </div>

          </div>

        </div>
      </div>
    </div>

    <div class="panel-footer borders">
      <form v-on:submit="sendMessage">
        <div class="help-block" v-if="$auth.user().id === consultant.id">Your messages are confidential and will not be visible to other contacted experts</div>
        <div class="help-block" v-else>Your messages are confidential</div>
        <div class="input-group">
          <input type="text" v-model="message" class="form-control" placeholder="Type your message here...">
          <div class="input-group-btn">
            <vue-ladda type="submit" :loading="submit.loading" id="btn_send" class="btn btn-info" :data-style="submit.dataStyle" @click="sendMessage">Send</vue-ladda>
          </div>
        </div>
      </form>
    </div>

  </div>
</template>
<style scoped>
  .chat-discussion{
    /*background-color: #e5dfdf;*/
  }
  .chat-users {
    margin: 0 -15px;
    cursor: pointer;
  }

  .chat-user.active {
    background-color: rgba(64, 64, 64, 0.08);
  }
</style>
<script>
import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda},
  props: ['questionId'],
  name: 'Chat',
  data () {
    return {
      message: '',
      refresh: false,
      consultant: null,
      chatUsers: [],
      messages: [],
      messageDetails: [],
      interlocutor: null,
      errorMessage: null,
      submit: {
        loading: false,
        'dataStyle': ''
      },
      conversation: [],
      user: null
    }
  },
  methods: {
    getResources: function () {
      this.axios.get('/question/' + this.questionId + '?relations={consultant}')
        .then((response) => {
          this.consultant = response.data.consultant

          if (this.$auth.user().id === this.consultant.id) {
            this.axios.get('/question/' + this.questionId + '/experts')
              .then((response) => {
                this.chatUsers = response.data
                if (this.chatUsers.length) {
                  this.setInterlocutor(this.chatUsers[0])
                }
              })
              .catch((error) => {
              })
          } else {
            this.setInterlocutor(this.consultant)
          }
        })
        .catch((error) => {
          if (error.response.status === 403) {
            this.$router.replace({name: 'Error403', params: {'0': ''}})
          }
          if (error.response.status === 404) {
            this.$router.replace({name: 'Error404', params: {'0': ''}})
          }
        })
    },
    setInterlocutor: function (user) {
      this.interlocutor = user
    },
    getConversation: function (user) {
      this.axios.get('/question/' + this.questionId + '/chat/' + user.id)
        .then((response) => {
          this.conversation = response.data
          this.scrollToEnd()
        })
        .catch((error) => {
        })
    },
    sendMessage: function (event) {
      event.preventDefault()
      this.submit.loading = true
      this.errorMessage = null

      this.axios.post('/question/' + this.questionId + '/chat', {
        message: this.message,
        receiver_id: this.interlocutor.id
      })
        .then((response) => {
          this.submit.loading = false
          this.message = null

          this.getConversation(this.interlocutor)
        })
        .catch((error) => {
          let errors = error.response.data.errors
          switch (error.response.data.code) {
            case 11:
              this.errorTitle = errors['message'][0]
              break
          }
          this.submit.loading = false
        })
    },
    scrollToEnd: function () {
      let container = this.$el.querySelector('#chat-discussion')
      container.scrollTop = container.scrollHeight
    }
  },
  watch: {
    interlocutor: function (user) {
      this.getConversation(user)
    }
  },
  updated () {
    this.scrollToEnd()
  },
  beforeMount () {
    this.getResources()
    this.user = this.$auth.user()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chatSolution/Chat.vue